import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

const OutstandingPrefooter = (props) => {

    let buttonText = '';
    let color = '';
    let typeButton = '';
    const {data} = props;
    if(!data) return '';
    if (!data.active) return false;

    color = data.color;
    
    if (color === "ligth-gray"){
        typeButton = "primary-btn";
    }else {
        typeButton = "special-btn";
    }
    
    if (data.button_text){
        buttonText =  data.button_text;
    }else{
        buttonText =  "Ver más";
    }

    const promotionClick = () => {
        let pathName = window.location.pathname;
        TagManagerService.interaction( `click: ${buttonText}`, pathName, 'Prefooter destacado');
    }

    return <section className={'outstanding-prefooter '+ color}>
        <span className='outstanding-prefooter-title'>{data.title}</span>
        <span className='outstanding-prefooter-text'>{data.text}</span>
        <Link to={data.url} target={data.url_target} className={'button '+ typeButton} onClick={() => promotionClick()}>{buttonText}</Link>
    </section>;
}

OutstandingPrefooter.propTypes = {
    data: PropTypes.object
};

export default OutstandingPrefooter;
